import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getInvioiceChargesService = (params = {}) => {
  return api.get(url.GET_ALL_INVOICE_CHARGES, params);
};

export const addInvioceChargesService = (requestParams = {}) => {
  return api.create(url.POST_INVOICE_CHARGES, requestParams, false, {}, true);
};

export const deleteInvoiceChargesService = (id) => {
  return api.delete(url.DELETE_INVOICE_CHARGES(id));
};

export const editInvoiceChargesService = (id, queryParams) => {
  return api.put(url.PUT_INVOICE_CHARGES(id), queryParams, {}, false, true);
};

export const editChargesNoteService = (id, queryParams) => {
  return api.put(url.PUT_CHARGES_NOTE(id), {}, queryParams, true);
};

export const getChargesBillIdService = (id) => {
  return api.get(url.GET_EXTRA_BILL_BY_ID(id));
};

export const getBillInvioiceChargesPDFService = (id) => {
  return api.get(
    url.DOWNLOAD_CHARGES_PDF(id),
    {},
    {
      withCredentials: true,
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    }
  );
};
